import { RewardsComingSoon } from "@/components/rewards/RewardsComingSoon";

/**
 * Rewards (formerly "My SPIF claims") — parked behind a "coming soon"
 * placeholder per CHP-430. The old SpifList UI stays on disk
 * (components/spifs/*) for later revival, but this route renders the
 * placeholder. Rewards is NOT cancelled — see ADR-0033 (supersedes ADR-0031 §4)
 * and workboard decisions/portfolio-gaps-decisions.md (D1).
 */
export function PartnerSpifsListRoute() {
  return <RewardsComingSoon audience="partner" />;
}
